import { useIntl } from '@/intl'
import { useState } from 'react'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    reportedDetails: {
      label: translate({ id: 'orders.preview.execution.section.reportedDetails' }),
    },
    checkIn: {
      label: translate({ id: 'orders.preview.execution.field.checkIn' }),
    },
    checkOut: {
      label: translate({ id: 'orders.preview.execution.field.checkOut' }),
    },
    status: {
      label: translate({ id: 'orders.preview.execution.field.status' }),
    },
    detectedDetails: {
      label: translate({ id: 'orders.preview.execution.section.detectedDetails' }),
    },
    detectedCheckIn: {
      label: translate({ id: 'orders.preview.execution.field.detectedCheckIn' }),
    },
    detectedCheckOut: {
      label: translate({ id: 'orders.preview.execution.field.detectedCheckOut' }),
    },
    serviceTime: {
      label: translate({ id: 'orders.preview.execution.field.serviceTime' }),
    },
    customFields: {
      label: translate({ id: 'orders.preview.execution.section.customFields' }),
    },
    orderId: {
      label: translate({ id: 'orders.preview.execution.field.orderId' }),
    },
    phone: {
      label: translate({ id: 'orders.preview.execution.field.phone' }),
    },
    PODs: {
      label: translate({ id: 'orders.preview.execution.section.pods' }),
    },
    note: {
      label: translate({ id: 'orders.preview.execution.field.note' }),
    },
    pictures: {
      label: translate({ id: 'orders.preview.execution.field.pictures' }),
    },
    signature: {
      label: translate({ id: 'orders.preview.execution.field.signature' }),
    },
    customerSignature: {
      label: translate({ id: 'orders.preview.execution.customerSignature' }),
    },
    picture: {
      label: translate({ id: 'orders.preview.execution.picture' }),
    },
    voiceMemo: {
      label: translate({ id: 'orders.preview.execution.field.voiceMemo' }),
      playbackSpeed: translate({ id: 'orders.preview.execution.voiceMemo.playbackSpeed' }),
      playbackSpeedNormal: translate({
        id: 'orders.preview.execution.voiceMemo.playbackSpeedNormal',
      }),
      turnOnVolume: translate({ id: 'orders.preview.execution.voiceMemo.turnOnVolume' }),
      turnOffVolume: translate({ id: 'orders.preview.execution.voiceMemo.turnOffVolume' }),
    },
    barcodes: {
      label: translate({ id: 'orders.preview.execution.section.barcodes' }),
    },
    driverBarcodes: {
      label: translate({ id: 'orders.preview.execution.section.driverBarcodes' }),
    },
    addedFromDriver: {
      label: translate({ id: 'orders.field.barcode.driverBarcodes' }),
    },
    scanned: {
      label: translate({ id: 'orders.preview.execution.field.scanned' }),
    },
    unreadable: {
      label: translate({ id: 'orders.preview.execution.field.unreadable' }),
    },
    missingBarcodes: {
      label: translate({ id: 'orders.preview.execution.field.missingBarcodes' }),
    },
    missingPackages: {
      label: translate({ id: 'orders.preview.execution.field.missingPackages' }),
    },
    unscanned: {
      label: translate({ id: 'orders.preview.execution.field.unscanned' }),
    },
    loads: {
      label: translate({ id: 'orders.preview.execution.section.loads' }),
    },
    showOnMap: {
      label: translate({ id: 'orders.preview.execution.fileMenuItem.showOnMap' }),
    },
    hideOnMap: {
      label: translate({ id: 'orders.pod.hideOnMap' }),
    },
    downLoadImage: {
      label: translate({ id: 'orders.preview.execution.fileMenuItem.downloadImage' }),
    },
    download: {
      label: translate({ id: 'global.download' }),
    },
    undeclared: {
      label: translate({ id: 'orders.preview.execution.value.undeclared' }),
    },
    reportedStatus: {
      label: translate({ id: 'orders.preview.execution.field.reportedStatus' }),
    },
    deliveryNote: {
      label: translate({ id: 'orders.preview.execution.deliveryNote' }),
    },
    statusMissing: {
      label: translate({ id: 'orders.preview.execution.status.missing' }),
    },
    statusReschedule: {
      label: translate({ id: 'orders.preview.execution.status.reschedule' }),
    },
    statusDone: {
      label: translate({ id: 'orders.preview.execution.status.done' }),
    },
    reportedStatusReason: {
      label: translate({ id: 'orders.form.reportedStatusReason' }),
    },
    reportedStatusWithDate: (date: string) =>
      translate({
        id: 'orders.preview.execution.field.reportedStatusWithDate',
        values: { date },
      }),
    noServiceTimeRecorded: {
      label: translate({ id: 'orders.preview.execution.noServiceTimeRecorded' }),
    },
    serviceTimeValue: (minutes: number) =>
      translate({
        id: 'orders.preview.execution.serviceTimeValue',
        values: { minutes },
      }),
    serviceTimeTooltip: translate({ id: 'orders.preview.execution.serviceTimeTooltip' }),
  }))

  return api
}
